<template>
    <div class="mindmap-lawful-interception-guide" :class="{ 'mindmap-dark-theme': isDarkTheme }"
        :data-theme="isDarkTheme ? 'dark' : 'light'">

        <!-- <div ref="contentToDownload" class="mindmap-markdown-content" v-if="notes.mk_notes" v-html="renderedNotes"></div> -->
        <div ref="markmapbox" class="mindmap-markmapbox">
            <div class="mindmap-mindmap-controls">
                <!-- <el-tooltip 
                    content="下载思维导图"
                    placement="left-end" 
                    effect="light"
                    :popper-class="'mindmap-custom-tooltip'"
                > -->
                <i @click="downloadMindmap(down_mk_notes)" class="el-icon-download mindmap-control-btn"
                    :class="{ 'mindmap-is-loading': isDownloading }"
                    :style="{ cursor: isDownloading ? 'not-allowed' : 'pointer' }"></i>
                <!-- </el-tooltip> -->
                <!-- <el-tooltip 
                    content="自适应视图"
                    placement="left-end" 
                    effect="light"
                    :popper-class="'mindmap-custom-tooltip'"
                > -->
                <i @click="fitView()" class="el-icon-refresh-left mindmap-control-btn"></i>
                <!-- </el-tooltip> -->
                
                <!-- <el-tooltip 
                    content="全屏查看"
                    placement="left-end" 
                    effect="light"
                    :popper-class="'mindmap-custom-tooltip'"
                > -->
                <i @click="openFullscreenDialog()" class="el-icon-full-screen mindmap-control-btn"></i>
                <!-- </el-tooltip> -->
            </div>
            <div id="markmapcontainer" class="mindmap-markmap-wrapper">
                <svg id="markmapsvg"></svg>
            </div>

            <div v-if="naotuloading" class="mindmap-loading-overlay">
                <div class="mindmap-loading-spinner"></div>
                <p>加载思维导图中...</p>
            </div>
        </div>
        
        <!-- 全屏弹窗 -->
        <div v-if="fullscreenDialogVisible" class="mindmap-custom-fullscreen-dialog">
            <div class="mindmap-fullscreen-container">
                <div class="mindmap-fullscreen-controls">
                    <i @click="resetZoom()" class="el-icon-zoom-out mindmap-fullscreen-control-btn"></i>
                    <i @click="closeFullscreenDialog()" class="el-icon-close mindmap-fullscreen-control-btn"></i>
                </div>
                <div id="fullscreenMarkmapContainer" class="mindmap-fullscreen-markmap-wrapper">
                    <svg id="fullscreenMarkmapSvg"></svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MarkdownIt from "markdown-it";
// import hljs from "highlight.js";
import { Transformer } from "markmap-lib";
import { Markmap } from "markmap-view";
import html2canvas from 'html2canvas';
// import { saveAs } from 'file-saver';
// import { jsPDF } from 'jspdf'
export default {
    props: {
        noteobj: {
            type: Object,
            default: () => ({}),
        },
    },
    watch: {
        noteobj: {
            handler(newobject) {
                this.iscreating = this.noteobj.status;
                this.notes["iscreating"] = newobject.status;
                this.notes["taskcount"] = newobject.task_count;
                // this.notes["iscreating"] = 0;
                this.notes["mk_notes"] = newobject.note_text;

                if (newobject.filetype == 'record' && newobject?.live_transcript?.part_objs) {
                    this.transcript = newobject.live_transcript;
                    let mknotes = ''
                    this.transcript?.part_objs.forEach((item) => {
                        item['mk_notes'] = this.md.render(item.notes);
                        mknotes = mknotes + item.notes
                    });
                    this.daoduTomarkmap(mknotes);
                } else {
                    this.daoduTomarkmap(newobject.note_text);
                }
            },
            deep: true, // 添加深度监听
        },
    },
    computed: {
        renderedNotes() {
            if (!this.notes || typeof this.notes.mk_notes !== "string") {
                return ""; // 或者返回一个默认消息，如 "No notes available"
            }
            return this.md.render(this.notes.mk_notes);
        },
    },
    data() {
        return {
            md: new MarkdownIt({
                html: true,
                linkify: true,
                typographer: true,
                // highlight: function (str, lang) {
                //     if (lang && hljs.getLanguage(lang)) {
                //         try {
                //             return hljs.highlight(lang, str).value;
                //         } catch (__) {
                //             console.log("error", str, lang);
                //         }
                //     }
                //     return ""; // 使用默认的转义
                // },
            }),
            notes: {
                mk_notes: "",
                iscreating: 0,
            },
            transcript: {},
            mm: null,
            fullscreenMm: null,
            naotuloading: false,
            down_mk_notes: '',
            isDownloading: false,
            isDarkTheme: false,
            resizeObserver: null,
            themeTransitioning: false, // 新增：用于跟踪主题是否正在过渡
            themeChangeTimeout: null, // 新增：主题切换的延时器
            isMobile: false, // 新增：检测是否为移动设备
            fullscreenDialogVisible: false, // 全屏弹窗是否可见
            currentZoomLevel: 1, // 当前缩放级别
        };
    },
    mounted() {
        this.notes["iscreating"] = this.noteobj.status;
        this.notes["mk_notes"] = this.noteobj.note_text;
        this.notes["type"] = this.noteobj.progress;
        this.notes["taskcount"] = this.noteobj.task_count;

        if (this.noteobj.filetype == 'record' && this.noteobj?.live_transcript?.part_objs) {
            this.transcript = this.noteobj.live_transcript;
            let mknotes = ''
            this.transcript?.part_objs.forEach((item) => {
                item['mk_notes'] = this.md.render(item.notes);
                mknotes = mknotes + item.notes
            });
            this.daoduTomarkmap(mknotes);
        } else {
            this.daoduTomarkmap(this.notes.mk_notes);
        }

        // 监听主题变化事件
        this.$parent.$on('theme-changed', this.onThemeChange);
        // 初始加载主题
        this.isDarkTheme = localStorage.getItem('easynote-theme-preference') === 'dark';

        // 检测是否为移动设备
        this.checkIfMobile();
        
        // 监听窗口大小变化
        this.setupResizeObserver();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        // 移除事件监听器
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }

        // 移除ESC键监听
        document.removeEventListener('keydown', this.handleEscKey);

        // 清理主题切换的延时器
        if (this.themeChangeTimeout) {
            clearTimeout(this.themeChangeTimeout);
        }

        // 清理标记图
        if (this.mm) {
            this.mm.destroy();
            this.mm = null;
        }
        
        // 清理全屏标记图
        if (this.fullscreenMm) {
            this.fullscreenMm.destroy();
            this.fullscreenMm = null;
        }
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        setupResizeObserver() {
            if ('ResizeObserver' in window) {
                this.resizeObserver = new ResizeObserver(this.handleResize);
                const container = document.getElementById('markmapcontainer');
                if (container) {
                    this.resizeObserver.observe(container);
                }
            }
        },
        handleResize() {
            // 防抖处理
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                this.checkIfMobile();
                if (this.mm && this.down_mk_notes) {
                    this.fitView();
                }
            }, 300);
        },
        onThemeChange(isDark) {
            // 避免重复处理正在进行的主题切换
            if (this.themeTransitioning) {
                return;
            }
            
            // 如果主题未变化，则不处理
            if (this.isDarkTheme === isDark) {
                return;
            }
            
            this.themeTransitioning = true;
            this.isDarkTheme = isDark;
            
            // 清除之前的延时器
            if (this.themeChangeTimeout) {
                clearTimeout(this.themeChangeTimeout);
            }
            
            // 使用防抖来避免频繁重绘
            this.themeChangeTimeout = setTimeout(() => {
                if (this.mm && this.down_mk_notes) {
                    // 更新标记图样式，无需完全重新渲染
                    this.mm.setOptions({
                        color: (node) => this.getNodeColor(node),
                        style: this.getCustomStyle()
                    });
                    
                    // 适应视图
                    this.fitView();
                }
                this.themeTransitioning = false;
            }, 300);
        },
        async daoduTomarkmap(markobj) {

            if (!markobj) {
                return;
            }
            if (this.down_mk_notes) {
                return;
            }
            this.down_mk_notes = markobj
            this.naotuloading = true;
            await this.rendernaotu(markobj); // 等待渲染完成

        },
        async rendernaotu(markstr) {
            try {
                if (this.mm) {
                    this.mm.destroy();
                    this.mm = null;
                }

                // 获取容器
                const container = document.getElementById('markmapcontainer');
                if (!container) {
                    console.error("markmapcontainer not found");
                    return;
                }

                // 清空容器
                container.innerHTML = '';

                // 创建新的SVG元素
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.setAttribute("id", "markmapsvg");
                svg.setAttribute("width", "100%");
                svg.setAttribute("height", "100%");
                container.appendChild(svg);

                // 解析内容
                const transformer = new Transformer();
                const { root } = await transformer.transform(markstr);

                // 确保SVG元素已加载
                await new Promise(resolve => setTimeout(resolve, 50));

                const markmapsvg = document.getElementById("markmapsvg");
                if (!markmapsvg) {
                    console.error("markmapsvg element not found");
                    return;
                }

                // 针对移动设备优化配置
                const isMobile = window.innerWidth <= 768;
                const spacingHorizontal = isMobile ? 60 : 100;
                const maxWidth = isMobile ? 300 : 500; // 只保留增加的maxWidth以容纳表格
                
                // 优化思维导图配置
                this.mm = Markmap.create(markmapsvg, {
                    zoom: true,
                    pan: true,
                    autoFit: true,  // 自动适应视图大小
                    color: (node) => this.getNodeColor(node),
                    padding: isMobile ? [20, 20, 20, 20] : [40, 30, 40, 30],  // 移动设备使用更小的边距
                    style: this.getCustomStyle(),
                    nodeMinHeight: 20,
                    spacingVertical: 8,         // 恢复原来的垂直间距
                    spacingHorizontal: spacingHorizontal,     // 水平间距
                    lineHeight: 1.4,           // 更舒适的行高
                    maxWidth: maxWidth,             // 限制节点宽度
                    duration: 500,             // 平滑动画
                    linkShape: 'diagonal',     // 使用对角线类型的连接线
                    curveRadius: 10,           // 曲线半径
                });

                // 设置数据
                this.mm.setData(root);

                this.naotuloading = false;
                
                // 确保适应视图
                setTimeout(() => {
                    if (this.mm) {
                        this.fitView();
                    }
                }, 100);
            } catch (error) {
                console.error("Error rendering mindmap:", error);
                this.naotuloading = false;
            }
        },
        getCustomStyle() {
            // 确保深色模式使用明亮的文字颜色
            const textColor = this.isDarkTheme ? '#ffffff' : '#333333';
            const subTextColor = this.isDarkTheme ? '#e6e6e6' : '#555555';
            const circleColor = this.isDarkTheme ? '#3a3a3a' : '#ffffff';
            const linkColor = this.isDarkTheme ? '#cccccc' : '#999999';

            return `
            .markmap-node {
                cursor: pointer;
                transition: all 0.3s ease;
            }
            .markmap-node-circle {
                fill: ${circleColor};
                stroke-width: 2px;
                r: 5px;
                transition: all 0.3s ease;
            }
            .markmap-node-text {
                fill: ${textColor} !important;
                font-size: 14px;
                font-weight: 500;
                font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
                transition: fill 0.3s ease;
            }
            .markmap-node-text tspan {
                font-weight: 400;
                fill: ${subTextColor} !important;
            }
            .markmap-link {
                stroke: ${linkColor};
                stroke-width: 1.5px;
                transition: stroke 0.3s ease;
                stroke-opacity: 0.8;
            }
            .markmap-node:hover .markmap-node-circle {
                r: 6px;
            }
            `;
        },
        getNodeColor(node) {
            // 使用更和谐的颜色方案
            const lightColors = [
                '#1976D2', // 蓝色
                '#0288D1', // 浅蓝
                '#7B1FA2', // 紫色
                '#C2185B', // 玫红色
                '#00796B', // 青绿色
                '#689F38', // 橄榄绿
                '#FFA000', // 琥珀色
                '#F57C00'  // 橙色
            ];

            const darkColors = [
                '#58a6ff', // 亮蓝色
                '#79c0ff', // 天蓝色
                '#d2a8ff', // 浅紫色
                '#ff9bce', // 粉色
                '#7ee787', // 浅绿色
                '#a5d6a7', // 薄荷绿
                '#ffca28', // 金黄色
                '#ffa726'  // 橙色
            ];

            const colors = this.isDarkTheme ? darkColors : lightColors;

            // 根据节点深度和位置给予不同颜色
            let level = 0;
            if (node.depth) {
                level = node.depth % colors.length;

                // 使用父节点索引来使相邻节点颜色更有变化
                if (node.parent && node.parent.children) {
                    const index = node.parent.children.indexOf(node);
                    if (index !== -1) {
                        level = (level + Math.floor(index / 2)) % colors.length;
                    }
                }
            }

            return colors[level];
        },
        fitView() {
            if (!this.mm) return;
            this.mm.fit();
        },
        getHTMLAsPromise(nameid) {
            return new Promise((resolve, reject) => {
                const checkElement = () => {
                    const svgElement = document.getElementById(nameid);
                    if (svgElement) {
                        resolve(svgElement);
                    } else {
                        // 如果元素不存在，等待一段时间后再次检查
                        setTimeout(() => {
                            const retryElement = document.getElementById(nameid);
                            if (retryElement) {
                                resolve(retryElement);
                            } else {
                                reject(new Error("SVG element not found after retry"));
                            }
                        }, 100);
                    }
                };

                this.$nextTick(checkElement);
            });
        },
        async downloadMindmap(down_mk_notes) {
            if (this.isDownloading) return;

            this.isDownloading = true;
            try {
                // 估算内容大小
                const contentSize = this.estimateContentSize(down_mk_notes);

                // 创建临时容器
                const tempContainer = document.createElement('div');
                tempContainer.style.position = 'absolute';
                tempContainer.style.left = '-9999px';
                tempContainer.style.width = `${contentSize.width}px`;
                tempContainer.style.height = `${contentSize.height}px`;

                // 创建新的SVG元素
                const tempSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                tempSvg.setAttribute('id', 'temp-markmap-svg');
                tempSvg.setAttribute('width', '100%');
                tempSvg.setAttribute('height', '100%');
                tempSvg.style.backgroundColor = 'white';

                tempContainer.appendChild(tempSvg);
                document.body.appendChild(tempContainer);

                try {
                    const transformer = new Transformer();
                    const { root } = await transformer.transform(down_mk_notes);

                    const mm = Markmap.create(tempSvg, {
                        zoom: false,
                        pan: false,
                        maxWidth: Math.min(contentSize.width - 40, 5000), // 保留增加的maxWidth以容纳表格
                        paddingX: 20,
                        duration: 0,
                        autoFit: true,
                        style: `
                        .markmap-node {
                            cursor: pointer;
                        }
                        .markmap-node-circle {
                            fill: #fff;
                            stroke-width: 1.5px;
                        }
                        .markmap-node-text {
                            fill: #333;
                            font-size: 16px;
                        }
                        .markmap-link {
                            stroke: #999;
                            stroke-width: 1.5px;
                        }
                        `
                    });

                    mm.setData(root);
                    mm.fit();

                    await new Promise(resolve => setTimeout(resolve, 300)); // 增加等待时间确保渲染完成

                    const canvas = await html2canvas(tempContainer, {
                        backgroundColor: '#ffffff',
                        scale: 2,
                        logging: false,
                        width: contentSize.width,
                        height: contentSize.height,
                        allowTaint: true,
                        useCORS: true,
                    });

                    const imgData = canvas.toDataURL('image/png', 1.0);
                    const link = document.createElement('a');
                    link.download = 'mindmap.png';
                    link.href = imgData;
                    link.click();
                } finally {
                    document.body.removeChild(tempContainer);
                }
            } catch (error) {
                console.error('下载脑图时发生错误:', error);
                this.$message.error('Downloading mindmap failed. Please try again later.');
            } finally {
                this.isDownloading = false;
            }
        },
        estimateContentSize(content) {
            const lines = content.split('\n').filter(line => line.trim());
            const maxLineLength = Math.max(...lines.map(line => line.length));
            
            // 检测是否包含表格
            const hasTable = content.includes('|') && content.includes('---');
            
            // 基础尺寸
            let baseWidth = hasTable ? 1600 : 1200;  // 如果有表格，增加基础宽度
            let baseHeight = hasTable ? 1000 : 800;  // 如果有表格，增加基础高度

            // 根据内容复杂度调整尺寸
            const width = Math.max(
                baseWidth,
                Math.min(maxLineLength * (hasTable ? 20 : 12), hasTable ? 5000 : 3000)  // 表格需要更多宽度
            );

            const height = Math.max(
                baseHeight,
                Math.min(lines.length * (hasTable ? 20 : 12), hasTable ? 10000 : 8000)  // 表格需要更多高度
            );

            return {
                width: Math.round(width),
                height: Math.round(height)
            };
        },
        // 打开全屏弹窗
        async openFullscreenDialog() {
            this.fullscreenDialogVisible = true;
            this.currentZoomLevel = 1;
            
            // 添加ESC键监听
            document.addEventListener('keydown', this.handleEscKey);
            
            // 等待弹窗DOM渲染完成
            await this.$nextTick();
            
            // 渲染全屏思维导图
            if (this.down_mk_notes) {
                this.renderFullscreenMindmap(this.down_mk_notes);
            }
        },
        
        // 关闭全屏弹窗
        closeFullscreenDialog() {
            // 移除ESC键监听
            document.removeEventListener('keydown', this.handleEscKey);
            
            if (this.fullscreenMm) {
                this.fullscreenMm.destroy();
                this.fullscreenMm = null;
            }
            
            this.fullscreenDialogVisible = false;
        },
        
        // 处理ESC键
        handleEscKey(event) {
            if (event.key === 'Escape' && this.fullscreenDialogVisible) {
                this.closeFullscreenDialog();
            }
        },
        
        // 渲染全屏思维导图
        async renderFullscreenMindmap(markstr) {
            try {
                if (this.fullscreenMm) {
                    this.fullscreenMm.destroy();
                    this.fullscreenMm = null;
                }

                // 获取容器
                const container = document.getElementById('fullscreenMarkmapContainer');
                if (!container) {
                    console.error("fullscreenMarkmapContainer not found");
                    return;
                }

                // 清空容器
                container.innerHTML = '';

                // 创建新的SVG元素
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.setAttribute("id", "fullscreenMarkmapSvg");
                svg.setAttribute("width", "100%");
                svg.setAttribute("height", "100%");
                container.appendChild(svg);

                // 解析内容
                const transformer = new Transformer();
                const { root } = await transformer.transform(markstr);

                // 确保SVG元素已加载
                await new Promise(resolve => setTimeout(resolve, 50));

                const markmapsvg = document.getElementById("fullscreenMarkmapSvg");
                if (!markmapsvg) {
                    console.error("fullscreenMarkmapSvg element not found");
                    return;
                }

                // 全屏模式下的配置
                const spacingHorizontal = 120;
                const maxWidth = 600; // 只保留增加的maxWidth以容纳表格
                
                // 优化思维导图配置
                this.fullscreenMm = Markmap.create(markmapsvg, {
                    zoom: true,
                    pan: true,
                    autoFit: true,
                    color: (node) => this.getNodeColor(node),
                    padding: [60, 40, 60, 40],
                    style: this.getCustomStyle(),
                    nodeMinHeight: 24,
                    spacingVertical: 10,
                    spacingHorizontal: spacingHorizontal,
                    lineHeight: 1.5,
                    maxWidth: maxWidth,
                    duration: 500,
                    linkShape: 'diagonal',
                    curveRadius: 12,
                });

                // 设置数据
                this.fullscreenMm.setData(root);
                
                // 确保适应视图
                setTimeout(() => {
                    if (this.fullscreenMm) {
                        this.fullscreenMm.fit();
                    }
                }, 100);
            } catch (error) {
                console.error("Error rendering fullscreen mindmap:", error);
            }
        },
        
        // 重置视图
        resetZoom() {
            if (this.fullscreenMm) {
                try {
                    this.fullscreenMm.fit();
                } catch (error) {
                    console.error('重置视图时出错:', error);
                }
            }
        },
    },
};
</script>

<style lang="less" scoped>
.mindmap-lawful-interception-guide {
    color: var(--text-color, #333333);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    transition: color 0.3s ease, background-color 0.3s ease;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 10px auto;
    .mindmap-markmapbox {
        height: 80vh;
        padding: 0;
        overflow: hidden;
        flex-grow: 1;
        position: relative;
        width: 98%;
        min-height: 550px;
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        background-color: var(--mindmap-bg, #f1f1f5);
        box-shadow: 0 2px 8px var(--shadow-color, rgba(0, 0, 0, 0.08));

        .mindmap-mindmap-controls {
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 10;
            display: flex;
            flex-direction: column;
            gap: 8px;

            .mindmap-control-btn {
                background-color: #ffffff;
                color: #555555;
                border: none;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
                width: 32px;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.2s ease;

                &:hover {
                    color: #333333;
                    background-color: #f5f5f5;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                }

                &.mindmap-is-loading {
                    background-color: #f0f0f0;
                    opacity: 0.8;
                    animation: mindmap-rotating 2s linear infinite;
                }
            }
        }

        .mindmap-markmap-wrapper {
            width: 100%;
            height: 100%;
            flex-grow: 1;
            display: flex;
            position: relative;
            overflow: hidden;
        }

        #markmapsvg {
            flex: 1;
            width: 100%;
            height: 100%;
            transition: background-color 0.3s ease;

            g {
                transform-origin: center center;
            }
        }

        .mindmap-loading-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: var(--mindmap-bg, rgba(241, 241, 245, 0.8));
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 20;
            transition: background-color 0.3s ease;

            .mindmap-loading-spinner {
                width: 40px;
                height: 40px;
                border: 4px solid rgba(255, 255, 255, 0.3);
                border-top: 4px solid var(--primary-color, #1976D2);
                border-radius: 50%;
                animation: mindmap-spin 1.5s linear infinite;
                margin-bottom: 15px;
            }

            p {
                color: var(--text-color, #333);
                font-size: 16px;
            }
        }
    }
}

@keyframes mindmap-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes mindmap-rotating {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* CSS变量 - 浅色主题 */
:root {
    --text-color: #333333;
    --primary-color: #1976D2;
    --primary-hover: #1565C0;
    --button-bg: #fff;
    --button-text: #fff;
    --mindmap-bg: #f1f1f5;
    --line-color: #999;
    --shadow-color: rgba(0, 0, 0, 0.08);
}

/* 深色主题的CSS变量 */
.mindmap-dark-theme .mindmap-lawful-interception-guide,
.mindmap-lawful-interception-guide[data-theme="dark"] {
    --text-color: #f0f0f0;
    --primary-color: #58a6ff;
    --primary-hover: #2188ff;
    --button-bg: #2a2a2a;
    --button-text: #f0f0f0;
    --mindmap-bg: #f1f1f5;
    /* 保持与浅色主题相同的背景 */
    --line-color: #aaa;
    --shadow-color: rgba(0, 0, 0, 0.3);
    
    .mindmap-control-btn {
        background-color: #333333;
        color: #e0e0e0;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
        
        &:hover {
            color: #ffffff;
            background-color: #444444;
        }
        
        &.mindmap-is-loading {
            background-color: #404040;
        }
    }
    
    .mindmap-fullscreen-control-btn {
        background-color: #333333;
        color: #e0e0e0;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
        
        &:hover {
            color: #ffffff;
            background-color: #444444;
        }
    }
}

.mindmap-custom-fullscreen-dialog {
    background-color: rgba(0, 0, 0, 0.7);
    margin: 0;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    overflow: hidden;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: mindmap-fade-in 0.3s ease;
}

@keyframes mindmap-fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.mindmap-fullscreen-container {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: transparent;
    border-radius: 8px;
    background-color: #fff;
    .mindmap-fullscreen-controls {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 100;
        display: flex;
        gap: 10px;
        
        .mindmap-fullscreen-control-btn {
            background-color: #ffffff;
            color: #555555;
            border: none;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.2s ease;
            
            &:hover {
                color: #333333;
                background-color: #f5f5f5;
                transform: translateY(-2px);
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            }
        }
    }
    
    .mindmap-fullscreen-markmap-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        position: relative;
        overflow: hidden;
        
        #fullscreenMarkmapSvg {
            flex: 1;
            width: 100%;
            height: 100%;
        }
    }
}

@media (max-width: 768px) {
    .mindmap-mindmap-controls {
        top: 5px;
        right: 5px;
        gap: 5px;
        
        .mindmap-control-btn {
            width: 28px;
            height: 28px;
            font-size: 14px;
        }
    }
    
    .mindmap-fullscreen-controls {
        top: 10px !important;
        right: 10px !important;
        gap: 5px;
        
        .mindmap-fullscreen-control-btn {
            width: 28px !important;
            height: 28px !important;
            font-size: 14px !important;
        }
    }
    
    .mindmap-lawful-interception-guide {
        .mindmap-markmapbox {
            height: calc(100vh - 170px);
            width: 100%;
            margin: 0;
            padding: 0;
            border-radius: 0;
        }
    }
}
</style>

<style lang="less">
.mindmap-custom-tooltip {
    padding: 8px 12px !important;
    font-size: 14px !important;
    color: var(--primary-color, #1976D2) !important;
    border: 1px solid var(--primary-color, #1976D2) !important;
    background-color: var(--tooltip-bg, #fff) !important;
    box-shadow: 0 2px 8px var(--shadow-color, rgba(25, 118, 210, 0.1)) !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;

    .popper__arrow {
        border-bottom-color: var(--primary-color, #1976D2) !important;

        &::after {
            border-bottom-color: var(--tooltip-bg, #fff) !important;
        }
    }
}

.mindmap-dark-theme .mindmap-custom-tooltip {
    --tooltip-bg: #2a2a2a;
    --shadow-color: rgba(0, 0, 0, 0.3);
}

</style>